import { parseError } from "apollo";

const Errors = ({
  className = "flex justify-center flex-col items-center z-30 flex-1",
  error,
}) => {
  return (
    <div className={`text-pink-500 font-bold ${className}`}>
      Error: {parseError(error)}
    </div>
  );
};

export default Errors;
